import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConstants} from '../@core/common/constants/app-constants';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  public token: string;
  public userName: string;

constructor(private http: HttpClient) {
 }
handleError(error: HttpErrorResponse) {
  let errorMessage = 'Unknown error!';
  if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Lỗi: ${error.error.message}`;
  } else if (error.error instanceof Object) {
      errorMessage = `Lỗi: ${error.error.Message}`;
  } else {
      // Server-side errors
      errorMessage = `Mã Lỗi: ${error.status}\nMessage: ${error.message}`;
  }
  if (error.status === 0)
  // tslint:disable-next-line: one-line
  {
      errorMessage = 'Lỗi kết nối máy chủ';
  }
  return throwError(errorMessage);
}
login(username: string, password: string) {
  const body = {
      'UserName': username,
      'Password': password,
  };
  return this.http.post<any>(AppConstants.LOGIN, body)
  .pipe();
}
register(username: string, firstname: string, midlename: string, lastname: string, officeId: string, phone: string) {
  const body = {
      'Email': username + AppConstants.endTail,
      'FirstName': firstname,
      'MidleName': midlename,
      'LastName': lastname,
      'MobilePhone': phone,
      'OfficeId': officeId,
  };
  return this.http.post<any>(AppConstants.REGISTER, body)
  .pipe(catchError(this.handleError));
}
logout() {
  // remove user from local storage to log user out
  this.token = null;
  localStorage.removeItem('UserName');
  localStorage.removeItem('Token');
  localStorage.removeItem('RoleId');
  localStorage.clear();
}
isLoggedIn() {
  if (localStorage.getItem('UserName')) {
      return true;
  }
  return false;
}
getTokenKey() {
  return this.token;
}


}
